function getLastLiveChatIndex(curHistory) {
    let livechatIndex = -1;
    for (let i = curHistory.length - 1; i >= 0; i--) {
        if (curHistory[i].extensionData && curHistory[i].extensionData.MessageSource === "LiveChat") {
            livechatIndex = i;
            break;
        }
    }
    return livechatIndex;
}
async function loadAlmeHistory(almeApiUtils) {
    let curHistory = [];
    let livechatIndex = -1;
    try {
        curHistory = await almeApiUtils.loadAlmeHistory();
        livechatIndex = getLastLiveChatIndex(curHistory);
        // Disable all auto navigation on history load.
        curHistory.forEach((response, index) => {
            if (response) {
                response.fromHistory = true;
                if (livechatIndex !== -1 && index <= livechatIndex) {
                    response.isLinkDisabled = true;
                }
                if (response.navUrl) {
                    response.navUrl.AutoNavigationType = 'None';
                }
            }
        });
    }
    catch (error) {
        console.error(error);
    }
    return curHistory;
}
export default loadAlmeHistory;
